import httpClient from '@/api/httpClient'
import Constant from '@/constant/index'
import ECAUtil from '@/utils/ecaUtil'
import { POST } from '@/api/api'
import Utils from '@/utils/index'
import distanceUtil from '@/utils/distanceUtil'
import _ from 'lodash'
import numeral from 'numeral'
import MapUtil from '@/utils/mapUtil'

const state = {
  isGettedDistance: false, // 得到数据未绘制
  isGettedDistanceFail: false, //
  finishedTrack: false, // 是否完成地图与绘制
  isNeedCalAfterRebuild: false,
  resetEstiMap: false,

  portPointArr: [],
  originPortPointArr: [],
  preservedPortPointArr: [],

  useEca: true,
  speed: 12,

  preservedOriginRoutes: [], // 原始航线 修改时或第一次 (已处理过 加上了routeSeq)
  originRoutes: [], // 原始航线 (已处理过 加上了routeSeq) 主要用于修改时

  routePoints: [], // 航线点数据
  routePaths: [], // 未经过ECA区域的航线路径
  routeWithECA: [], // 经过ECA区域的航线路径

  routePorts: [], // 港口间航程数据
  routeOnlyPorts: [], // 合并后港口间航程数据 不含转向点
  ttlDistance: 0, // 总航程
  ttlEcaDistance: 0, // 经过ECA区域的航程
  ttlSeaTime: 0, // 总的航行时间

  trackVisible: false,
  ecaAreas: [], // eca区域的数组
  ecaLines: [], // eca边线的数组

  mapCurrentPoint: null,

  turningPoints: [], // 转向点数组
  turnLayerVisible: false,
  resetTurnLayerFlag: false,

  //
  resetWayPointFlag: false,
  routeLayerVisible: false, // 标示是否显示路由点
  excWayPointArr: _.cloneDeep(MapUtil.EXC_WAYPOINT_DEFAULT_ARR),
  copyExcWayPointArr: [],
  preservedExcWayPointArr: [],

  requiredWayPointArr: [],
  originRequiredWayPointArr: [], // 主要用于修改时
  wayPointConfig: _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
}

// getters
const getters = {

}

// actions
const actions = {
  async getDistanceForEsti ({ commit, state, rootState, dispatch }, payload = {}) {
    const res = await POST('/CalcDis4Mobile', {
      OperID: Utils.getWithExpiry('operID'),
      PortStr: payload.portIdStr,
      ExcRoutePoint: rootState.route.excWayPointArr.join(',')
    })
    // Your day limit is over.You can try again tomorrow ---310001
    var routes = res.routePoints
    // console.log(routes);
    commit('handleAndStoreRoutes', routes)
    dispatch('reBuildRoutesForEsti')
  },

  async getDistanceForEstimating ({ commit, state, rootState, dispatch }, payload = {}) {
    const res = await POST('/CalcDis4Mobile', {
      OperID: Utils.getWithExpiry('operID'),
      PortStr: payload.portIdStr,
      ExcRoutePoint: rootState.route.excWayPointArr.join(',')
    })
    var routes = res.routePoints
    // console.log(routes);
    commit('handleAndStoreRoutes', routes)
    commit('setPreservedOriginRoutes', state.originRoutes)

    var portPointArr = []
    rootState.estimating.portsRotationArr.forEach((ele, index) => {
      var o = {}
      o.PortID = ele.port.portId
      o.PortName = ele.port.fullName
      o.FullName = ele.port.portName
      o.lon = ele.port.longitude
      o.lat = ele.port.latitude
      portPointArr.push(o)
    })
    commit('setPortPointArrEsti', portPointArr)
    commit('setOriginPortPointArrEsti', portPointArr)

    // commit("setPreservedPortIdStr", payload.portIdStr)
    dispatch('reBuildRoutesForEsti')
  },

  async reBuildRoutesForEsti ({ rootState, commit }) {
    if (state.originRoutes && state.originRoutes.length > 0) {
      let routes = distanceUtil.reBuildLinePoint(state.originRoutes) // 是否要clone?
      routes = await ECAUtil.buildRoutePointsWithECA(state.ecaAreas, routes)

      commit('setRoutePointsForEsti', routes) // 更新航线数据
      commit('setTurningPointForEsti', _.cloneDeep(routes)) // ??

      commit('buildDistanceResultForEsti', { rootState: rootState }) // 生成航程计算的结果
      commit('createTrackPathForEsti') // 创建航线轨迹数据
      // dispatch("buildPortResult") //
      // 关闭路由
      commit('setIsGettedDistanceForEsti', true)
      commit('setIsGettedDistanceFailForEsti', false)

      // return route
    } else {
      commit('setIsGettedDistanceForEsti', false)
      commit('setIsGettedDistanceFailForEsti', true)
    }
  }

  /**
  async getDistanceForEstimating({ commit, rootState, dispatch }, payload = {}) {
    let res = await POST("/CalcDis4Mobile", {
      OperID: Utils.getWithExpiry("operID"),
      PortStr: payload.portIdStr,
      ExcRoutePoint: rootState.route.excWayPointArr.join(",")
    })

    var routes = res.routePoints
    if (routes) {
      let route = distanceUtil.reBuildLinePoint(routes)
      if (false) {
        route = await ECAUtil.buildRoutePointsWithECA(state.ecaAreas, route)
      } else {
        route.forEach(item => {
          ECAUtil.calcRoutePointDistanceVal(item.route);
          item.distance = item.route[item.route.length - 1].gVal;
        })
      }
      commit("setRoutePoints", route) // 更新航线数据
      return route
    }
  },
  */

} // end actions

// mutations
const mutations = {
  setIsGettedDistanceForEsti (state, payload) {
    state.isGettedDistance = payload
  },
  setIsGettedDistanceFailForEsti (state, payload) {
    state.isGettedDistanceFail = payload
  },
  setResetEstiMap (state, payload) {
    state.resetEstiMap = payload
  },

  setFinishedTrack (state, payload) {
    state.finishedTrack = payload
  },
  setIsNeedCalAfterRebuild (state, payload) {
    state.isNeedCalAfterRebuild = payload
  },

  setPortPointArrEsti (state, payload) { // 算是一次性提交
    state.portPointArr = payload
  },
  setOriginPortPointArrEsti (state, payload) {
    state.originPortPointArr = _.cloneDeep(payload)
  },
  setPreservedPortPointArrEsti (state, payload) {
    state.preservedPortPointArr = payload
  },

  // 控制是否显示航线
  showTrackForEsti (state, payload) {
    state.trackVisible = payload
  },

  // 存储原始航线数据
  handleAndStoreRoutes (state, payload) {
    let routeSeq = 0
    payload.forEach((ele, index) => {
      // ele.distance && delete ele.distance
      ele.route.forEach((e, i) => {
        e.routeSeq = routeSeq
        routeSeq++
      })
    })

    state.originRoutes = payload
  },

  setOriginRoutesEsti (state, payload) {
    state.originRoutes = _.cloneDeep(payload)
  },

  setPreservedOriginRoutes (state, payload) {
    state.preservedOriginRoutes = _.cloneDeep(payload)
  },

  // 设置航线的点的数据
  setRoutePointsForEsti (state, payload) {
    state.routePoints = payload
  },

  // 设置转向点数据
  setTurningPointForEsti (state, payload) {
    let points = []
    payload.forEach(item => {
      points = points.concat(item.route)
    })
    points = points.filter(item => {
      return item.hasOwnProperty('routeSeq') && item.wn !== 'eca'
    })
    state.turningPoints = points
  },
  // 修改转向点
  updateRouteFromRawForEsti (state, payload) {
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const temp = item.route.find(ele => {
        return ele.routeSeq == payload.id
      })
      if (temp) {
        temp.lon = payload.longitude
        temp.lat = payload.latitude
        break
      }
    }
  },

  // 添加转向点
  addRouteFromRawForEsti (state, payload) {
    let sum = 0
    for (let i = 0; i < state.originRoutes.length; i++) {
      sum += state.originRoutes[i].route.length
    }
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const ind = item.route.findIndex(ele => {
        return ele.routeSeq == payload.id
      })
      if (ind !== -1) {
        const obj = {
          gVal: numeral(distanceUtil.greatCircleDist(
            item.route[ind].lon, item.route[ind].lat,
            payload.lon,
            payload.lat
          )).format('0,0.00'),
          routeSeq: sum,
          lon: payload.lon,
          lat: payload.lat,
          wt: '1'
        }
        item.route.splice(ind + 1, 0, obj)
        break
      }
    }
  },
  // 删除转向点
  delRouteFromRawForEsti (state, payload) {
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const ind = item.route.findIndex(item => {
        return item.routeSeq == payload.id
      })
      if (ind !== -1) {
        item.route.splice(ind, 1)
        break
      }
    }
  },

  // 创建航程计算结果
  buildDistanceResultForEsti (state, payload) {
    var routes = state.routePoints
    var ttlDistance = 0; var ttlEcaDistance = 0
    var distance = 0; var ecaDistance = 0
    var ttlSeaTime = 0
    var routePorts = [] // 存放港口和港口间距离

    for (var i = 0; i < routes.length; i++) {
      var route = routes[i].route
      ttlDistance += routes[i].distance
      distance += routes[i].distance
      if (routes[i].eca) {
        ecaDistance += routes[i].distance
        ttlEcaDistance += routes[i].distance
      }

      for (var j = 0; j < route.length; j++) {
        // 加入港口间距离
        if (j == 0 && i == 0) {
          var startPortObj = _.cloneDeep(route[j])
          startPortObj.gVal = 0
          startPortObj.ecaVal = 0
          startPortObj.time = 0
          routePorts.push(startPortObj)
        } else if (j == route.length - 1) {
          if (route[j].wn == 'eca') continue

          var toPortObj = _.cloneDeep(route[j])
          toPortObj.gVal = distance
          toPortObj.ecaVal = ecaDistance
          // toPortObj.time = _.round(toPortObj.gVal / (state.speed * 24), 2)
          ttlSeaTime += toPortObj.time

          routePorts.push(toPortObj)
          distance = ecaDistance = 0
        }
      }
    }

    state.routePoints = routes
    state.routePorts = routePorts
    state.ttlSeaTime = _.round(ttlSeaTime, 2)
    state.ttlEcaDistance = _.round(ttlEcaDistance, 2)
    state.ttlDistance = _.round(ttlDistance, 2)

    let myRouteOnlyPorts = []
    if (state.routePorts.some(ele => (ele.wt == '1' || ele.wt == '2'))) { // 含有转向点
      const routePortsLen = state.routePorts.length
      myRouteOnlyPorts.push(state.routePorts[0])

      let gValSum = 0; let timeSum = 0
      for (let n = 1; n < routePortsLen; n++) {
        var ele = _.cloneDeep(state.routePorts[n])
        if (ele.wt == '1' || ele.wt == '2') { // 转向点  time gVal
          gValSum += ele.gVal
          timeSum += ele.time
        } else {
          ele.gVal += gValSum
          ele.time += timeSum
          myRouteOnlyPorts.push(ele)
          gValSum = 0
          timeSum = 0
        }
      }
    } else {
      myRouteOnlyPorts = state.routePorts
    }

    myRouteOnlyPorts.forEach((ele, index) => {
      if (payload.rootState.estimating.portsRotationArr.length > 0 &&
        (payload.rootState.estimating.portsRotationArr[index].taskType ==
          Constant.TASK_TYPE_BALLAST ||
        payload.rootState.estimating.portsRotationArr[index].taskType ==
          Constant.TASK_TYPE_DISCHARING)) { ele.time = _.round(ele.gVal / (payload.rootState.estimating.shipInfo.SpeedBallast * 24), 2) } else {
        ele.time = _.round(ele.gVal / (payload.rootState.estimating.shipInfo.SpeedLaden * 24), 2)
      }
    })
    
    state.routeOnlyPorts = myRouteOnlyPorts
    //console.log("state.routeOnlyPorts",state.routeOnlyPorts)
  },

  createTrackPathForEsti (state) {
    state.routePaths = []
    state.routeWithECA = []
    let tempArr = []
    for (let i = 0; i < state.routePoints.length; i++) {
      const obj = state.routePoints[i]
      var arr = []
      let ids = []
      var deltaDegree = 0
      var crosses180Direction = 0
      var route = _.cloneDeep(obj.route)
      for (let j = 0; j < route.length; j++) {
        if (j > 0) {
          // 同一位置的，跳过
          if (
            route[j - 1].lon == route[j].lon &&
              route[j - 1].lat == route[j].lat &&
              route[j - 1].wt != '0' &&
              route[j].wt != '0'
          ) { continue }
          crosses180Direction = distanceUtil.judgeCrosses180Degrees(
            route[j - 1],
            route[j]
          )
          if (crosses180Direction == 1)
          // 由东向西
          { deltaDegree += 360 } else if (crosses180Direction == -1)
          // 由西向东
          { deltaDegree -= 360 }

          const lon = route[j].lon + deltaDegree
          if (route[j].wt == '11' || route[j].wt == '19' || route[j].wn == 'eca') {
            arr.push([lon, route[j].lat])
          }
          if (arr.length && route[j].wt != '11' && route[j].wt != '19') {
            arr.push([lon, route[j].lat])
            route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
            if (ids[0] !== 'eca' && ids[1] == 'eca') {
              const no = state.turningPoints.findIndex(item => {
                return item.routeSeq == ids[0]
              })
              ids = [state.turningPoints[no].routeSeq, state.turningPoints[no + 1].routeSeq]
              tempArr = ids
            }
            if ((ids[0] == 'eca' && ids[1] !== 'eca') || (ids[0] == 'eca' && ids[1] == 'eca')) {
              ids = tempArr
            }
            const temp = {
              distance:
                numeral(distanceUtil.greatCircleDist(
                  arr[0][0], arr[0][1],
                  arr[arr.length - 1][0],
                  arr[arr.length - 1][1])
                ).format('0,0.00'),
              route: arr,
              idArr: ids
            }
            if (obj.eca) {
              state.routeWithECA.push(temp)
            } else {
              state.routePaths.push(temp)
            }
            arr = []
            ids = []
            arr.push([lon, route[j].lat])
            route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
          }
        } else {
          arr.push([route[j].lon, route[j].lat])
          route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
        }
      }
    }
  }, // end createTrackPath2

  changeTurnLayerVisibleForEsti (state, payload) {
    state.turnLayerVisible = payload
  },

  setResetTurnLayerFlagForEsti (state, payload) {
    state.resetTurnLayerFlag = payload
  },

  clearDistanceForEsti (state, payload) {
    state.isGettedDistance = false
    // state.isCompleteDistance = false
    state.finishedTrack = false
    state.isNeedCalAfterRebuild = false

    state.originRoutes = []
    state.preservedOriginRoutes = []
    state.routePoints = []
    state.routePorts = []
    state.routeOnlyPorts = []

    state.turnLayerVisible = false
    state.resetTurnLayerFlag = false

    state.ttlDistance = 0
    state.ttlEcaDistance = 0
    state.ttlSeaTime = 0

    state.routePaths = []
    state.routeWithECA = []

    state.routeLayerVisible = false
    state.excWayPointArr = _.cloneDeep(MapUtil.EXC_WAYPOINT_DEFAULT_ARR)
    state.copyExcWayPointArr = []
    state.preservedExcWayPointArr = []

    state.requiredWayPointArr = []
    state.originRequiredWayPointArr = []
    state.wayPointConfig = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)

    state.resetEstiMap = true
  },

  addRequiredWayPointToPortPointArrEsti (state, payload) {
    state.portPointArr.splice(payload.index, 0, payload)
  },
  removeRequiredWayPointFromPortPointArrEsti (state, payload) {
    var index = state.portPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index !== -1) {
      state.portPointArr.splice(index, 1)
    }
  },

  setRouteLayerVisibleEsti (state, payload) { // 改变路由点的显示状态
    state.routeLayerVisible = payload
  },

  setResetWayPointFlagEsti (state, payload) {
    state.resetWayPointFlag = payload
  },

  setWayPointConfigEsti (state, payload) {
    state.wayPointConfig = payload
  },

  resetWayPointArrEsti (state, payload) { // copyExcWayPointArr
    state.excWayPointArr = _.cloneDeep(MapUtil.EXC_WAYPOINT_DEFAULT_ARR)
    state.copyExcWayPointArr = []
    state.preservedExcWayPointArr = []
    state.requiredWayPointArr = _.cloneDeep(state.originRequiredWayPointArr)

    state.wayPointConfig = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
  },

  updateExcWayPointArrEsti (state, payload) {
    var index = state.excWayPointArr.indexOf(payload.waypointID)
    if (index !== -1) {
      if (payload.option !== MapUtil.WAYPOINT_TYPE_EXC) { state.excWayPointArr.splice(index, 1) }
    } else {
      // 数组中没有，但禁止通过的添加进数组
      if (payload.option == MapUtil.WAYPOINT_TYPE_EXC) { state.excWayPointArr.push(payload.waypointID) }
    }

    var copyIndex = state.copyExcWayPointArr.indexOf(payload.waypointID)
    if (copyIndex !== -1) {
      if (payload.option !== MapUtil.WAYPOINT_TYPE_EXC) { state.copyExcWayPointArr.splice(copyIndex, 1) }
    } else {
      // 数组中没有，但禁止通过的添加进数组
      if (payload.option == MapUtil.WAYPOINT_TYPE_EXC) { state.copyExcWayPointArr.push(payload.waypointID) }
    }
  },

  setPreservedExcWayPointArrEsti (state, payload) {
    state.preservedExcWayPointArr = payload
  },

  setRequiredWayPointEsti (state, payload) {
    state.requiredWayPointArr = payload
  },
  setOriginRequiredWayPointArr (state, payload) {
    state.originRequiredWayPointArr = _.cloneDeep(payload)
  },
  addRequiredWayPointEsti (state, payload) {
    var index = state.requiredWayPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index == -1) {
      state.requiredWayPointArr.push(payload)
    }
  },
  removeRequiredWayPointEsti (state, payload) {
    var index = state.requiredWayPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index !== -1) {
      state.requiredWayPointArr.splice(index, 1)
    }
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
